import { jwtDecode } from "jwt-decode";

export function extractUserFromToken(token) {
  try {
    if (!token) return null;

    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    if (decoded.exp && decoded.exp < currentTime) {
      return null;
    }

    return {
      id: decoded.id,
      email: decoded.username,
      fullName: `${decoded.first_name || ""} ${decoded.last_name || ""}`.trim(),
      firstName: decoded.first_name || "",
      lastName: decoded.last_name || "",
      gender: decoded.gender || "",
    };
  } catch (error) {
    console.error("Erreur lors du décodage du token JWT:", error);
    return null;
  }
}

export function validateUserRole(token, expectedRole) {
  try {
    if (!token) return false;

    console.log(expectedRole,"expected role");

    const decoded = jwtDecode(token);
    const roles = decoded.roles || [];

    if (expectedRole === "veterinaire") {
      return roles.includes("CODE_VETERINAIRES");
    } else if (expectedRole === "client") {
      return roles.includes("CODE_CLIENTS");
    } else if (expectedRole === "delegues") {
      return roles.includes("CODE_DELEGUES");
    }

    return false;
  } catch (error) {
    console.error("Erreur lors de la validation du rôle:", error);
    return false;
  }
}
